import React from 'react';
import api from '@tutorbot/directory-api';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import { LocalizationContext } from '../../../hoc/Localization';
import { UserContext } from '../../../hoc/User';
import StepContainer from '../StepContainer';

import CategorySelector from './CategorySelector';
import CourseTypeSelector from './CourseTypeSelector';
import SubjectSelector from './SubjectSelector';

const SelectCategory = () => {
  const { t, translate, locale } = React.useContext(LocalizationContext);
  const { edited, updateContent } = React.useContext(EditorWizardContext);
  const { user } = React.useContext(UserContext);

  const [fetchedCategories, setFetchedCategories] = React.useState([]);
  const [fetchedCourseTypes, setFetchedCourseTypes] = React.useState([]);
  const [fetchedLanguages, setFetchedLanguages] = React.useState([]);

  React.useEffect(() => {
    if (!fetchedCategories.length) {
      (async () => {
        setFetchedCategories(await api().categories.all());
      })();
    }
    if (!fetchedCourseTypes.length) {
      (async () => {
        setFetchedCourseTypes(await api().courseTypes.all());
      })();
    }
    if (!fetchedLanguages.length) {
      (async () => {
        setFetchedLanguages(await api().languages.all());
      })();
    }
  }, []);

  if (process.browser) {
    React.useEffect(() => {
      if (window.fbq && !user) {
        window.fbq('trackCustom', 'WizardLoginShown');
      }
    }, [window.fbq]);
  }

  const { category = {}, coursetypes = {}, language = {} } = edited;

  const setValue = (data, key) => {
    updateContent(key, data);
  };

  return (
    <StepContainer
      nextButtonDisabled={
        !category.id || !coursetypes.id || !language.id
      }
    >
      <CategorySelector
        categories={fetchedCategories}
        t={t}
        name="wizard_course_category"
        locale={locale}
        onChange={selectedOption => {
          setValue(fetchedCategories.find(option => option.id === selectedOption), 'category');
        }}
        value={category[`title_${locale}`]}
        disabled={!user}
      />
      <CourseTypeSelector
        categories={fetchedCourseTypes}
        t={t}
        name="wizard_coursetypes"
        locale={locale}
        onChange={selectedOption => {
          setValue(
            fetchedCourseTypes.find(
              option =>
                option[`title_${locale}`] === selectedOption || option.title === selectedOption,
            ),
            'coursetypes',
          );
        }}
        value={coursetypes[`title_${locale}`] || coursetypes.title}
        disabled={!user}
        category={category}
      />
      <SubjectSelector
        subjects={fetchedLanguages}
        t={t}
        name="wizard_subject"
        locale={locale}
        onChange={selectedOption => {
          setValue(
            fetchedLanguages.find(
              option =>
                option[`Name_${locale}`] === selectedOption || option.Name === selectedOption,
            ),
            'language',
          );
        }}
        value={language[`Name_${locale}`] || language.title}
        disabled={!user}
        category={category}
      />
    </StepContainer>
  );
};

export default SelectCategory;
